(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/sportradar/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/sport/sportradar/assets/javascripts/prescript.js');
"use strict";


svs.sport = svs.sport || {};
svs.sport.sportradar = svs.sport.sportradar || {};

 })(window);